import { render } from "./MainCustomers.vue?vue&type=template&id=14b17824&scoped=true"
import script from "./MainCustomers.vue?vue&type=script&lang=js"
export * from "./MainCustomers.vue?vue&type=script&lang=js"

import "./MainCustomers.vue?vue&type=style&index=0&id=14b17824&scoped=true&lang=css"

import exportComponent from "D:\\facturacion electronica\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14b17824"]])

export default __exports__